
    import { initIris } from './iris.js'
    initIris()

    // Pre-select the service dropdown from ?service=<value> (Book Now / package CTAs)
    const params = new URLSearchParams(window.location.search)
    const service = params.get('service')
    if (service) {
      const select = document.getElementById('serviceSelect')
      const match = Array.from(select.options).find(o => o.value === service)
      if (match) select.value = service
    }

    const termsModal = document.getElementById('termsModal')
    const termsModalBody = document.getElementById('termsModalBody')

    async function openTermsModal(e) {
      e.preventDefault()
      if (!termsModalBody.dataset.loaded) {
        try {
          const res = await fetch('./terms.html')
          const html = await res.text()
          const doc = new DOMParser().parseFromString(html, 'text/html')
          const content = doc.querySelector('.panel-inner')
          const backLink = content && content.querySelector('.panel-cta')
          if (backLink) backLink.remove()
          if (content) {
            termsModalBody.innerHTML = content.innerHTML
            termsModalBody.dataset.loaded = 'true'
          }
        } catch (err) {
          termsModalBody.innerHTML = '<p>Couldn\'t load the terms. <a href="./terms.html" target="_blank" rel="noopener">Open in a new tab</a>.</p>'
        }
      }
      termsModal.hidden = false
      document.body.classList.add('modal-open')
    }

    function closeTermsModal() {
      termsModal.hidden = true
      document.body.classList.remove('modal-open')
    }

    document.querySelectorAll('.js-terms-link').forEach(link => {
      link.addEventListener('click', openTermsModal)
    })
    document.getElementById('termsModalClose').addEventListener('click', closeTermsModal)
    termsModal.addEventListener('click', (e) => {
      if (e.target === termsModal) closeTermsModal()
    })
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !termsModal.hidden) closeTermsModal()
    })

    document.getElementById('contactForm').addEventListener('submit', async (e) => {
      e.preventDefault()
      const form = e.target
      const data = new FormData(form)
      try {
        const res = await fetch(form.action, {
          method: 'POST',
          body: data,
          headers: { 'Accept': 'application/json' }
        })
        if (res.ok) {
          form.reset()
          document.getElementById('formSuccess').style.display = 'block'
        }
      } catch (err) {
        console.error('Form error:', err)
      }
    })

    const navToggle   = document.querySelector('.nav-toggle')
    const mobileNav   = document.getElementById('mobileNav')
    const mobileClose = document.querySelector('.mobile-nav-close')
    navToggle.addEventListener('click', () => mobileNav.classList.add('open'))
    mobileClose.addEventListener('click', () => mobileNav.classList.remove('open'))
    document.querySelectorAll('.mobile-nav-link').forEach(l => l.addEventListener('click', () => mobileNav.classList.remove('open')))
  